<template>
  <span class="new" :class="{ dot: isDot }">
    <span class="dot" v-if="isDot">·</span>
    <template v-else>new</template>
  </span>
</template>

<script setup lang="ts">
defineProps({
  isDot: { type: Boolean, default: false },
});
</script>

<style lang="less" scoped>
.new {
  color: rgba(#f00, 0.8);
  position: absolute;
  left: 4px;
  top: 4px;
  font-size: 12px;
  font-weight: bold;
  &.dot {
    font-size: 36px;
    line-height: 18px;
  }
}
</style>
